<mat-drawer-container id="release_notes_add_edit_main_container" autosize>
  <mat-card id="release_notes_add_edit_mat_card">
    <mat-card-content class="form-mat-card-content">
      <div id="release_notes_add_edit_header" class="page-header">
        <span id="release_notes_add_edit_header_text" class="page-header-text">
          {{ pageType() | titlecase }} Release Notes
        </span>
        <span class="spacer"></span>
        @if (!isViewed()) {
          <button
            mat-button
            id="release_notes_add_edit_cancel"
            class="add-edit-button white-button button-cancel-spacing"
            (click)="close()">
            Cancel
          </button>
        }
        @if (!isViewed()) {
          <button
            mat-button
            id="release_notes_add_edit_save"
            class="add-edit-button save-button"
            (click)="onSubmit()">
            Save
          </button>
        }
        @if (isViewed()) {
          <button
            mat-button
            id="release_notes_add_edit_close"
            class="add-edit-button white-button button-cancel-spacing"
            (click)="close()">
            Close
          </button>
        }
        @if (isViewed()) {
          <button
            mat-button
            id="release_notes_add_edit_save_2"
            class="add-edit-button save-button"
            [disabled]="sharedReleaseNotes()?.status === status.published"
            [ngClass]="{ 'invalid-button': sharedReleaseNotes()?.status === status.published }"
            (click)="navigateToEditScreen()">
            Edit
          </button>
        }
      </div>
      <hr class="custom-hr" />
      @if (!loading() && !formError()) {
        <div class="release-grid custom-form">
          <!-- LEFT COLUMN -->
          <form id="release_notes_form" class="left-panel" [formGroup]="releaseNotesForm">
            <div id="release_notes_add_edit_release_date" class="field">
              <div id="form_input_release_date" class="form-input-title">
                Release Date: <span>*</span>
              </div>
              <mat-form-field
                id="release_notes_release_date_field"
                class="form-field-custom form-field-input no-overflow">
                <input
                  matInput
                  id="release_notes_release_date_input"
                  class="shared-input-field release-date-input"
                  formControlName="tentativeReleaseAt"
                  placeholder="DD/MM/YYYY"
                  autocomplete="off"
                  [matDatepicker]="picker" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <span class="error-space-holder">
                  @if (
                    releaseNotesForm.controls['tentativeReleaseAt'].touched &&
                    !releaseNotesForm.controls['tentativeReleaseAt'].valid &&
                    !focusState()['tentativeReleaseAt']
                  ) {
                    <mat-error id="release_notes_release_date_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('tentativeReleaseAt') }}
                    </mat-error>
                  }
                </span>
              </mat-form-field>
            </div>
            <div id="release_notes_add_edit_title" class="field">
              <div id="form_input_title" class="form-input-title">Title: <span>*</span></div>
              <mat-form-field
                id="release_notes_title_field"
                class="form-field-custom form-field-input">
                <input
                  matInput
                  id="release_notes_title_input"
                  maxlength="40"
                  class="shared-input-field"
                  formControlName="title"
                  autocomplete="off"
                  placeholder="Enter Title Here..."
                  (focus)="onInputFocus('title')"
                  (blur)="onInputBlur('title')" />
                <span class="error-space-holder">
                  @if (
                    releaseNotesForm.controls['title'].touched &&
                    !releaseNotesForm.controls['title'].valid &&
                    !focusState()['title']
                  ) {
                    <mat-error id="release_notes_title_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('title') }}
                    </mat-error>
                  }
                </span>
              </mat-form-field>
            </div>
            <div id="release_notes_add_edit_product" class="field">
              <div id="form_input_title_product" class="form-input-title">
                Product: <span>*</span>
              </div>
              <mat-form-field
                id="release_notes_product_field"
                class="form-field-custom add-edit-dropdown">
                <mat-select
                  id="release_notes_product_select"
                  placeholder="Select Product"
                  formControlName="productId"
                  [value]="selectedProduct()"
                  (selectionChange)="onProductChange($event.value)">
                  @for (product of products(); track product) {
                    <mat-option id="release_notes_product_options_{{ product }}" [value]="product">
                      {{ product | formatProductName }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <span class="error-space-holder">
                @if (
                  releaseNotesForm.controls['productId'].touched &&
                  !releaseNotesForm.controls['productId'].valid &&
                  !focusState()['productId']
                ) {
                  <mat-error id="release_notes_product_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('productId') }}
                  </mat-error>
                }
              </span>
            </div>
            <div id="release_notes_add_edit_version" class="field">
              <div id="form_input_title_version" class="form-input-title">
                Version: <span>*</span>
              </div>
              <mat-form-field
                id="release_notes_version_field"
                class="form-field-custom form-field-input">
                <input
                  matInput
                  id="release_notes_version_input"
                  maxlength="9"
                  class="shared-input-field"
                  formControlName="version"
                  autocomplete="off"
                  placeholder="Enter Version Here..."
                  (focus)="onInputFocus('version')"
                  (blur)="onInputBlur('version')" />
                <span class="error-space-holder">
                  @if (
                    releaseNotesForm.controls['version'].touched &&
                    !releaseNotesForm.controls['version'].valid &&
                    !focusState()['version']
                  ) {
                    <mat-error id="release_notes_version_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('version') }}
                    </mat-error>
                  }
                  @if (productVersionExists()) {
                    <mat-error id="release_notes_version_error2" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ productVersionExistsMessage() }}
                    </mat-error>
                  }
                </span>
              </mat-form-field>
            </div>
            <div id="release_notes_add_edit_notes" class="field">
              <div id="form_input_title_notes" class="form-input-title">
                Release Notes: <span>*</span>
              </div>
              <mat-form-field
                id="release_notes_notes_field"
                class="form-field-custom form-field-input input-textarea">
                <textarea
                  matInput
                  id="release_notes_notes_textarea"
                  rows="7"
                  formControlName="summaryText"
                  class="summary-text"
                  maxlength="400"
                  autocomplete="off"
                  (focus)="onInputFocus('summaryText')"
                  (blur)="onInputBlur('summaryText')"></textarea>
                <span class="error-space-holder">
                  @if (
                    releaseNotesForm.controls['summaryText'].touched &&
                    !releaseNotesForm.controls['summaryText'].valid &&
                    !focusState()['summaryText']
                  ) {
                    <mat-error id="release_notes_notes_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('summaryText') }}
                    </mat-error>
                  }
                </span>
              </mat-form-field>
            </div>
            <div id="release_notes_add_edit_attach_file" class="field">
              <div id="form_input_title_attach_file" class="form-input-title">
                Attach Images / Videos:
                <span>*</span>
              </div>
              <div
                id="release_notes_attach_file"
                class="upload-area"
                [class.disabled]="
                  uploadedFiles().length > 0 || isViewed() || isFileUploadDisabled()
                "
                (drop)="
                  uploadedFiles().length === 0 && !isFileUploadDisabled() && onFileDrop($event)
                "
                (dragover)="
                  uploadedFiles().length === 0 && !isFileUploadDisabled() && onDragOver($event)
                "
                (click)="
                  uploadedFiles().length === 0 && !isFileUploadDisabled() && fileInput.click()
                ">
                <i class="fas fa-cloud-upload-alt upload-icon"></i>
                <p id="release_notes_attach_file_here">
                  Drop your image/video here, or <span>select</span> from your computer
                </p>
                <input
                  #fileInput
                  type="file"
                  hidden
                  accept="image/*,video/*"
                  [disabled]="isFileUploadDisabled()"
                  (change)="onFileSelected($event)" />
              </div>
              <div id="release_notes_file_upload_notes" class="empty-text">
                You must select a product and enter a version number before you can attach a file
              </div>
              @if (fileUploadError()) {
                <mat-error id="release_notes_files_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i>{{ fileUploadError() }}
                </mat-error>
              }
            </div>
          </form>
          <!-- RIGHT COLUMN -->
          <div class="right-panel">
            <div id="form_input_title_attached_file" class="form-input-title">
              Attached Images / Videos
            </div>
            <hr class="right-panel-hr" />
            @if (uploadedFiles().length > 0 && isPreview()) {
              <div class="attached-files">
                @for (file of uploadedFiles(); track file; let i = $index) {
                  <div class="file-item">
                    @if (file.type.startsWith('image')) {
                      <img alt="preview" class="file-preview" [src]="file.preview" />
                    }
                    @if (file.type.startsWith('video')) {
                      <video
                        class="file-preview"
                        controls
                        controlsList="nodownload"
                        [src]="file.preview"></video>
                    }
                    <div class="file-info">
                      @if (!isViewed()) {
                        <button
                          mat-button
                          id="confirm_button"
                          class="add-edit-button remove-button"
                          (click)="removeFile(i)">
                          Remove
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (uploadedFiles().length === 0 || !isPreview()) {
              <p class="empty-text">
                You haven't added any images/videos yet. Once uploaded, they will appear here.
              </p>
            }
            <hr class="custom-hr" />
            @if (!isViewed()) {
              <div id="release_notes_add_edit_enabled" class="buttons-row span-all-cols">
                <button
                  mat-button
                  id="release_notes_add_edit_cancel_2"
                  class="add-edit-button white-button"
                  (click)="close()">
                  Cancel
                </button>
                <button
                  mat-button
                  id="release_notes_add_edit_save_4"
                  class="add-edit-button save-button"
                  (click)="onSubmit()">
                  Save
                </button>
              </div>
            }
            @if (isViewed()) {
              <div id="release_notes_add_edit_close_enabled" class="buttons-row span-all-cols">
                <button
                  mat-button
                  id="release_notes_add_edit_close_2"
                  class="add-edit-button white-button"
                  (click)="close()">
                  Close
                </button>
                <button
                  mat-button
                  id="release_notes_add_edit_save_3"
                  class="add-edit-button save-button"
                  [disabled]="sharedReleaseNotes()?.status === status.published"
                  [ngClass]="{
                    'invalid-button': sharedReleaseNotes()?.status === status.published,
                  }"
                  (click)="navigateToEditScreen()">
                  Edit
                </button>
              </div>
            }
          </div>
        </div>
      }
      @if (loading()) {
        <app-loading-spinner />
      }
      @if (!loading() && formError()) {
        <app-form-error />
      }
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
